import { canAdministrate, canInventory, canReport } from "./permissions"

export class RouteInfo {
  constructor(path, ...permissions) {
    this.path = path
    this.permissions = permissions
  }
}

export const profilePage = new RouteInfo("profile", canAdministrate)
export const storagePage = new RouteInfo("storage", canAdministrate)
export const analyticsPage = new RouteInfo("analytics", canReport)
export const supplyPage = new RouteInfo("supply", canAdministrate)
export const salesPage = new RouteInfo("sales", canAdministrate)
export const salesReportPage = new RouteInfo("report", canAdministrate)
export const purchasesPage = new RouteInfo("purchases", canAdministrate)
export const employeesPage = new RouteInfo("employees", canAdministrate)
export const employeeProfilePage = new RouteInfo(
  "employee/:id",
  canAdministrate,
)
export const cashboxPage = new RouteInfo("cashbox", canAdministrate)
export const cashboxPageInfo = new RouteInfo("cashboxinfo/:id", canAdministrate)
export const selectStorePage = new RouteInfo("stores")
export const discountPage = new RouteInfo("discount", canAdministrate)
export const inventoriesPage = new RouteInfo("inventories", canInventory)
export const inventoryPage = new RouteInfo("inventory", canInventory)
export const ukmPage = new RouteInfo("ukm", canAdministrate)
export const productPage = new RouteInfo("product", canAdministrate)
export const paymentPage = new RouteInfo("payment", canAdministrate)
export const reportsPage = new RouteInfo("reports", canAdministrate)
export const reportPage = new RouteInfo("report-forms", canAdministrate)
export const addProductPage = new RouteInfo("add-product", canAdministrate)
export const ncaLayerComponent = new RouteInfo("nca-layer", canAdministrate)
